module.exports = __webpack_public_path__ + "img/request_sent.f8610c67.png";